export const pluginPrefix = 'PLUGIN:ENV_FEE:';
export const SET_EXCHANGE_PROCESS_STEP = `${pluginPrefix}SET_EXCHANGE_PROCESS_STEP`;
export const SET_PRODUCTS_FOR_EXCHANGE = `${pluginPrefix}SET_PRODUCTS_FOR_EXCHANGE`;
export const SET_ORIGINAL_SALES_DOCUMENT = `${pluginPrefix}SET_ORIGINAL_SALES_DOCUMENT`;
